import type { RootState } from '~/redux/store';
import type { Tag } from '~/types/models';
import type { IRestIndexParams } from '~/types/states';

export const getColumns = (state: RootState): string[] => {
  return state.tags.columns.index;
};

export const getParams = (state: RootState): IRestIndexParams<Tag> => ({
  sortBy: state.tags.sortBy,
  page: state.tags.page,
  pageSize: state.tags.pageSize,
  with: state.tags.with.join(','),
  ...state.tags.filters,
});

export const getItem = (state: RootState): Tag | null => state.tags.item;

export const getInitialItem = (state: RootState): string | null => state.tags.initialItem;
